import { styleConstants, styled } from 'src/styles/stitches.config'

export const TitleWrapper = styled('div', {
    padding: '$xl calc(4 * $colWidth) 0',
})

export const StyledGallery = styled('div', {
    position: `relative`,
    '.swiper-slide': {
        '@lgDown': {
            width: 'auto',
            marginRight: 30,
            '> img': {
                height: 300,
                width: 'auto',
            },
        },
        '@lg': {
            width: 'calc($colWidth * 4.8)',
            height: '95vh',

            '> img': {
                position: 'absolute',
                objectFit: 'cover',
                objectPosition: 'center',
            },
            '&.slide-1 img': {
                width: '75%',
                top: '50%',
                aspectRatio: '286/480',
                left: 0,
                transform: 'translateY(-50%)',
            },
            '&.slide-2 img': {
                width: 'calc(2 * $colWidth)',
                top: '20px',
                aspectRatio: '201/245',
                right: '$colWidth',
            },
            '&.slide-3 img': {
                width: 'calc(4 * $colWidth)',
                bottom: '0px',
                aspectRatio: '280/351',
                left: '0',
            },
            '&.slide-4 img': {
                width: 'calc(4 * $colWidth)',
                top: '0px',
                aspectRatio: '394/487',
                left: '-$colWidth',
            },
            '&.slide-5 img': {
                width: 'calc(6 * $colWidth)',
                maxWidth: 'calc(5.5 * $colWidth)',
                bottom: '0px',
                aspectRatio: '504/386',
                left: 'calc(-2 * $colWidth)',
            },
        },
    },
})
